
import LocalLaundryServiceIcon from "@mui/icons-material/LocalLaundryService";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useEffect, useState } from "react";
import { FaPlus, FaMinus } from "react-icons/fa";
import { Player } from "@lottiefiles/react-lottie-player";
import notFound from "../../../../assets/animation/notFount.json";

const AddOns = ({ laundry, onSelectionChange }) => {
    const showSnackbar = useSnackbar();
    const [inventoryData, setInventoryData] = useState([]);
    const isImageAvailable = !!laundry?.image;
    const [selectedItems, setSelectedItems] = useState([]);

    useEffect(() => {
        if (typeof onSelectionChange === "function") {
            onSelectionChange(selectedItems);

        }
    }, [selectedItems, onSelectionChange]);

    useEffect(() => {
        fetchInvetory();
    }, []);

    const fetchInvetory = () => {
        axiosInstance
            .get(
                `/customer/store/inventory/${laundry?.id}`
            )
            .then((res) => {
                const formattedUser = res?.data?.inventory?.map((item) => ({
                    id: item?.id || "",
                    name: item?.itemName || "",
                    itemDescription: item?.itemDescription,
                    price: "$" + item?.pricePerQuantity,
                    itemImageUrl: item?.itemImage || null,
                }));
                setInventoryData(formattedUser);
            })
            .catch((err) => {
                showSnackbar("Something went wrong!", "error");
            });
    };
    const increment = (item) => {
        setSelectedItems((prev) => {
            const exists = prev.find((i) => i.id === item.id);
            if (exists) {
                return prev.map((i) =>
                    i.id === item.id ? { ...i, qty: i.qty + 1 } : i
                );
            } else {
                return [...prev, { ...item, qty: 1 }];
            }
        });
    };

    const decrement = (item) => {
        setSelectedItems((prev) => {
            const exists = prev.find((i) => i.id === item.id);
            if (!exists) return prev; // nothing to do
            if (exists.qty === 1) {
                // remove when reaching 0
                return prev.filter((i) => i.id !== item.id);
            }
            return prev.map((i) =>
                i.id === item.id ? { ...i, qty: i.qty - 1 } : i
            );
        });
    };

    const getQty = (id) => {
        const found = selectedItems.find((i) => i.id === id);
        return found ? found.qty : 0;
    };

    return (
        <div className="flex flex-col  bg-[#f6f6f7] border border-[#D8DAE5] rounded-2xl p-3 overflow-auto space-y-3">
            <div className="text-lg font-bold text-[#063853]">Add Ons</div>
          <div className=" h-[500px] overflow-y-auto space-y-3 py-1">
              {inventoryData?.length > 0 &&
                inventoryData.map((item, idx) => (
                    <div className="flex flex-col  w-full bg-white  rounded-2xl p-2  shadow-md overflow-hidden ">

                        <div className="flex flex-row">

                            {/* Image wrapper */}
                            <div className=" h-16 w-[80px] bg-[#E8F3F8] rounded-xl overflow-hidden ">
                                {isImageAvailable ? (
                                    <img
                                        src={item?.itemImageUrl || laundry?.image}
                                        alt="Laundry"
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <LocalLaundryServiceIcon
                                        style={{ fontSize: 80 }}
                                        className="text-[#3383B2] mx-auto my-auto"
                                    />
                                )}
                            </div>

                            {/* Title + rating */}
                            <div className="flex flex-col justify-between pl-2 w-full">
                                <h5 className="font-semibold text-sm text-[#2F2F2F] text-start ">
                                    {item?.name}
                                </h5>

                                <div className="flex flex-row items-center  justify-between w-full  " >

                                    <h5 className="font-semibold text-sm text-[#2F2F2F] text-start ">
                                        {item?.price}

                                    </h5>
                                    <div className="flex items-center space-x-1 bg-[#DEEDF6] px-2 py-2 rounded-full">
                                        <button
                                            onClick={() => decrement(item)}
                                            className="w-[20px] h-[20px] text-[12px] flex justify-center items-center bg-[#F7F8F9] text-[#64748B] rounded-full">
                                            <FaMinus />
                                        </button>
                                        <span className="text-sm font-semibold w-6 text-center">
                                            {getQty(item.id)}
                                        </span>
                                        <button onClick={() => increment(item)}
                                            className="w-[20px] h-[20px] text-[12px] flex justify-center items-center bg-[#F7F8F9] text-[#64748B] rounded-full">
                                            <FaPlus />
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="font-medium text-xs text-[#2F2F2F] text-start mt-2"> {item?.itemDescription}</div>

                    </div>
                ))}

            {(!inventoryData || inventoryData.length === 0) && (
                  <div className="flex flex-col  items-center justify-center py-10 text-gray-500">
                            <Player
                              autoplay
                              loop
                              src={notFound}
                              style={{ height: "150px", width: "150px" }}
                            />
                            <p className="text-center text-sm md:text-base">
                              No add ons available
                            </p>
                          </div>
            )}
          </div>


        </div>

    );
};

export default AddOns;
